import { Controller } from "stimulus"
export default class extends Controller {
  static targets = ['formElement', 'childCheckbox', 'parentCheckbox', 'submitButton']
  // handle click before submit form
  handleSubmitModal(e){
    this.prepareData()
  }

  // prepare form data
  prepareData(){
    let followOnTests = [];

    this.getCheckedFollowOnTests.forEach(el=>{
      followOnTests.push({
        follow_on_id: el.value,
        specimen_id: el.dataset['specimenId']
      })
    })

    this.formElementTarget.querySelector('#follow_on_test_values').value = JSON.stringify(followOnTests)
  }

  checkAll(e){
    if (e.target.checked){
      this.changeCheckChild(true)
      this.submitButtonTarget.disabled = false
    }else{
      this.changeCheckChild(false)
      this.submitButtonTarget.disabled = true
    }
  }

  changeCheckChild(checked){
    this.childCheckboxTargets.forEach(element => {
      element.checked = checked
    });
  }

  checkOne(e){
    let anyChecked = this.childCheckboxTargets.some((e)=> e.checked)
    let allChecked = this.childCheckboxTargets.every((e)=> e.checked)

    if(allChecked){
      this.parentCheckboxTarget.checked = true
    }else{
      this.parentCheckboxTarget.checked = false
    }

    this.submitButtonTarget.disabled = !anyChecked
  }

  get anyChecked(){
    return this.childCheckboxTargets.some(element => element.checked = checked);
  }

  get getCheckedFollowOnTests(){
    return this.childCheckboxTargets.filter(element => element.checked);
  }
}